import { render, staticRenderFns } from "./BloodSugarPage.vue?vue&type=template&id=8d8fdd20&scoped=true&"
import script from "./BloodSugarPage.vue?vue&type=script&lang=js&"
export * from "./BloodSugarPage.vue?vue&type=script&lang=js&"
import style0 from "./BloodSugarPage.vue?vue&type=style&index=0&id=8d8fdd20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8fdd20",
  null
  
)

export default component.exports